import DetailedBookkeepingTable from './components/DetailedBookkeepingTable'

const Bookkeeping = () => {
  return <DetailedBookkeepingTable detailed />
}

export default Bookkeeping
